import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { useLoyaltyProgramStore } from "#imports";

export default defineNuxtRouteMiddleware((_to, from) => {
  const loyaltyProgramStore = useLoyaltyProgramStore();

  if (from.name === "order") return;

  if (
    !loyaltyProgramStore.isEnabled ||
    loyaltyProgramStore.service !== "native"
  ) {
    return navigateTo({ name: "order" }, { replace: true });
  }
});
